import React from 'react';
import PropTypes from 'prop-types';
import DescriptionBox from './DescriptionBox';
import HorizontalBarChart from './HorizontalBarChart';
import phrasesType from '../proptypes/phrases';
import archetypeMatchesType from '../proptypes/archetype-matches';
import selectArchetypeMatchesChartData from '../selectors/archetype-matches-chart';
import selectMatchDescriptionBoxContent from '../selectors/match-description-box-content';

const ArchetypeMatchesModule = ({ archetypeMatches, phrases, rolePath }) => {
  const matchData = archetypeMatches[0].archetypes;

  const chartRowData = selectArchetypeMatchesChartData(phrases, matchData, rolePath);
  const descriptionContent = selectMatchDescriptionBoxContent(phrases);

  return (
    <div className="archetype-matches-module py-5 px-2 px-auto-md">
      <div className="container my-auto">
        <div className="row mt-1 mb-4 my-lg-4">
          <div className="col-lg-7">
            <h1 className="role-matches-title">
              {phrases.roleMatchesTitle}
            </h1>
            <hr className="mini-divider my-3 stick-left" />
          </div>
          <div className="col-md role-matches-intro">
            <p>{phrases.roleMatchesIntro}</p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-7 mb-5">
            <HorizontalBarChart
              data-testid="spy-role-match-percentage-chart"
              formatValue={(ceil, val) => `${val}%`}
              ceilingValue={100}
              rows={chartRowData}
            />
          </div>
          <div className="col-md">
            <DescriptionBox content={descriptionContent} />
          </div>
        </div>
      </div>
    </div>
  );
};

ArchetypeMatchesModule.propTypes = {
  archetypeMatches: archetypeMatchesType.isRequired,
  phrases: phrasesType.isRequired,
  rolePath: PropTypes.string.isRequired,
};

export default ArchetypeMatchesModule;
